<template>
  <div class="key-metrics">
    <div v-for="stat in stats" :key="stat.title" class="stat-item">
      <b class="stat">{{ stat.count }}</b>
      <div class="stat-label">
        <span>{{ stat.title }}</span>
        <div class="stat-info">
          <span>i</span>
          <p>{{ stat.information }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KeyMetrics",
  props: {
    stats: { type: Array, required: true },
  },
  data() {
    return {};
  },
  components: {},
  computed: {},
  async created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";
.key-metrics {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 1rem;
}

.stat-item {
  flex: 1;
  text-align: center;

  .stat {
    font-size: $extraLargeFontSize;
  }

  .stat-label {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 0.5rem;

    span {
      display: block;
      font-size: $smallFontSize;
    }

    .stat-info {
      span {
        font-style: italic;
        margin-left: 0.25rem;
      }

      p {
        display: none;
        position: absolute;
        background: $blackColor;
        color: $whiteColor;
        font-size: $smallestFontSize;
        top: calc(100% + 0.25rem);
        left: 50%;
        transform: translateX(-50%);
        border-radius: 0.5rem;
        z-index: 1;
        width: 10rem;
        padding: 0.5rem;
      }
    }

    &:hover {
      .stat-info p {
        display: block;
      }
    }
  }

  &:first-child {
    margin-left: 0;
    padding-left: 0;
    border-left: none;
  }
}
</style>
